// extracted by mini-css-extract-plugin
export default {"modal":"EditModal_modal__Aoyzh","modalContent":"EditModal_modalContent__JQUDQ","buttons":"EditModal_buttons__YUnSz"};